/**
 * Os rótulos e as cores de um chamado (F051), para a lista e o detalhe do
 * site e do celular (F308). O site acrescenta só o ícone.
 */
export const TICKET_STATUS_TEXT = {
    open: { label: 'Aberto', tone: 'info' },
    in_progress: { label: 'Em andamento', tone: 'warning' },
    waiting: { label: 'Aguardando', tone: 'neutral' },
    closed: { label: 'Fechado', tone: 'success' },
};
export const TICKET_PRIORITY_TEXT = {
    urgent: {
        label: 'Urgente',
        tone: 'danger',
        hint: 'Alguém para o que está fazendo.',
    },
    high: {
        label: 'Alta',
        tone: 'warning',
        hint: 'Antes do resto da fila, ainda hoje.',
    },
    normal: {
        label: 'Normal',
        tone: 'neutral',
        hint: 'A ordem de chegada resolve.',
    },
    low: { label: 'Baixa', tone: 'neutral', hint: 'Quando sobrar tempo.' },
};
export const TICKET_EVENT_LABELS = {
    opened: 'Chamado aberto',
    note: 'Nota',
    status_changed: 'Situação alterada',
    assigned: 'Atribuído',
    closed: 'Fechado',
    reopened: 'Reaberto',
};
//# sourceMappingURL=tickets.js.map